import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import WebApp from "@twa-dev/sdk";

import { NavBar } from "./components/NavBar";
import { PlansScreen } from "./screens/PlansScreen";
import { CheckoutScreen } from "./screens/CheckoutScreen";
import { MySubscriptionScreen } from "./screens/MySubscriptionScreen";
import { DevicesScreen } from "./screens/DevicesScreen";
import { StubScreen } from "./screens/StubScreen";
import "./i18n";

export function App() {
  useEffect(() => {
    WebApp.ready();
    WebApp.expand();
  }, []);

  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<PlansScreen />} />
        <Route path="/checkout/:planId" element={<CheckoutScreen />} />
        <Route path="/subscription" element={<MySubscriptionScreen />} />
        <Route path="/devices" element={<DevicesScreen />} />
        <Route path="/change-plan" element={<StubScreen titleKey="change_plan_title" />} />
        <Route path="/payments" element={<StubScreen titleKey="payments_title" />} />
        <Route path="/cancel" element={<StubScreen titleKey="cancel_title" />} />
        <Route path="/promo" element={<StubScreen titleKey="promo_title" />} />
      </Routes>
    </BrowserRouter>
  );
}
